import React, { useEffect, useState } from "react";

import ButtonV2 from "../../../components/ui/button/v2";
import { CrossButton } from "../../../components/ui/button/v2/CrossButton";
import SelectDropdownV2 from "../../../components/ui/selectdropdown/v2";
import { OptionNameValuePair } from "../../../lib/interfaces/types";
import { cn } from "../../../lib/utils";

export interface StageWorkflowAssignOfficerModalProps {
  isOpen: boolean;
  options: OptionNameValuePair<string>[];
  onClose: () => void;
  onConfirm: (selectedValue: string) => void;
  title?: string;
  className?: string;
  loading?: boolean;  
  isFetchingOptions?: boolean;  
}

const StageWorkflowAssignOfficerModal: React.FC<
  StageWorkflowAssignOfficerModalProps
> = ({ isOpen, options, onClose, onConfirm,loading=false, title, isFetchingOptions=false, className }) => {
  const [selectedOption, setSelectedOption] =
    useState<OptionNameValuePair<string> | null>(null);

  useEffect(() => {
    if (!isOpen) setSelectedOption(null);
  }, [isOpen]);

  const canConfirm = !!selectedOption;

  const renderTitle = () => (
    <div className="font-sans text-lg font-semibold leading-[100%] tracking-normal text-[#0A0A0A] mb-4">
      {title ?? "Appoint Dealing Officer"}
    </div>
  );

  const renderAssignLabel = () => (
    <div className="font-sans text-sm font-medium leading-[100%] tracking-normal text-[#0A0A0A] mb-2">
      Assign
    </div>
  );

  const renderOfficerSelect = () => {
    if (isFetchingOptions) {
    return (
      <div className="mb-4 h-9 w-[377px] flex items-center justify-center border border-[#E5E5E5] rounded-md bg-white text-sm text-[#737373]">
        Loading...
      </div>
    );
    }

   return (    
    <div className="mb-4">
      <SelectDropdownV2<string>
        name="Officer"
        enableSearch={true}
        options={options}
        selectedOption={selectedOption ?? undefined}
        onSelectionChange={(opt) => setSelectedOption(opt)}
        containerClassName={cn(
          "h-9 w-[377px] border border-[#E5E5E5] rounded-md bg-white shadow-xs px-3 py-1 flex items-center",
        )}
        labelClassName={cn(
          "flex-1 text-sm font-normal leading-5 text-[#0A0A0A] font-sans w-full",
        )}
        focusClassName="outline outline-[2px] outline-indigo-200"
      />
    </div>
  );
}

  const handleConfirm = () => {
    if (!selectedOption) return;
    onConfirm(selectedOption.value);
  };

  const renderConfirmButton = () => (
    <ButtonV2
      variant="outline"
      size="md"
      onClick={handleConfirm}
      disabled={!canConfirm || loading || isFetchingOptions}
      loading={loading}
      className={cn(
        "h-9 w-[377px] border px-4 py-2 font-sans text-sm font-medium leading-5",
        "bg-[#EBEEFE] border-[#3551F3] text-[#3551F3]",
        "hover:bg-[#EBEEFE] hover:text-[#3551F3]",
        !canConfirm && "opacity-50 cursor-not-allowed",
      )}
    >
      Confirm
    </ButtonV2>
  );

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-[rgba(10,10,10,0.20)] flex items-center justify-center z-[9999]">
      <div
        className={cn(
          "relative bg-white border border-[#E5E5E5] rounded-lg shadow-lg p-6",
          "w-[425px] h-[192px]",
          className,
        )}
      >
        {<CrossButton onClick={onClose} disabled={loading} />}
        {renderTitle()}
        {renderAssignLabel()}
        {renderOfficerSelect()}
        {renderConfirmButton()}
      </div>
    </div>
  );
};

export default StageWorkflowAssignOfficerModal;
